import { createFeatureSelector } from '@ngrx/store';
import * as fromProjects from './projects.reducer';

export const selectProjectState =
  createFeatureSelector<fromProjects.ProjectState>(
    fromProjects.projectsFeatureKey,
  );
